export default __webpack_public_path__ + "static/media/coriolis-logo-light.9be4bc1f.png";